export const UserManualType = {
  INTERNAL: 'internal',
  EXTERNAL: 'external',
}
